import { Button } from "@material-tailwind/react";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "../../components/layout";

export default function WrongPayment() {
  const location = useLocation();
  let navigate = useNavigate();
  const { course } = location?.state || null;
  return (
    <Layout>
      <div className="container mx-auto">
        <div className="mt-4">
          <p className="text-2xl font-bold mb-4 text-red-500">
            Il pagamento non è andato a buon fine.
          </p>
          <p>
            Purtroppo il pagamento non è andato a buon fine. <br />
            Riprova o contattaci.
          </p>
          <div className="mt-4">
            <Button
              onClick={() =>
                navigate("/payment", { state: { course: course } })
              }
            >
              Torna al pagamento
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
